//- SCRIPTS DO ESPECIAL
jQuery(document).ready(function($) {
    $('.carousel-colaboradores').owlCarousel({
        margin:10,
        // loop:true,
        dots: true,
        items:5,
        responsive:{
            0:{
                autoWidth:true,
                margin: 10,
                items:1
            },
            490:{
                items:2
            },
            768:{
                items:3
            },
            1024:{
                nav: true,
                items:4
            },
            1200:{
                nav:true,
                items:5
            },
            3000:{
                nav:true,
                items:5
            }
        }
    });

    $(".btn-accordion").on('click', function(event) {
        event.preventDefault();
        $(this).parent().toggleClass('active');
        $(this).parent().siblings().removeClass('active');
    });

    // MONTA CAROUSEL NA AREA DE PREMIACOES SOMENTE MOBILE
    // Optimalisation: Store the references outside the event handler:
    var $window = $(window);

    function checkWidthExp() {
        var windowsize = $window.width();

        if (windowsize < 767) {

            // CAROUSEL MOBILE EQUIPE
            $(".carousel-equipe-mob").owlCarousel({
                loop: !0,
                margin: 0,
                items: 1,
                responsiveClass: !0,
                autoHeight: !1,
                responsive: {
                    0: {
                        items: 1,
                        nav: !0
                    },
                    600: {
                        items: 1,
                        nav: !0
                    },
                    1000: {
                        items: 1,
                        nav: !0
                    },
                    2000: {
                        items: 1,
                        nav: !0
                    }
                }
            });
            // FIM | CAROUSEL MOBILE EQUIPE

            // owlCarousel
            $('.carousel-premios').addClass('owl-carousel');
            $('.carousel-premios').owlCarousel({
                margin:0,
                dots: true,
                items:1,
            });
        }
    }
    // Execute on load
    checkWidthExp();
    // Bind event listener
    $(window).resize(checkWidthExp);
});
